import React, { useCallback, useEffect, useState } from 'react';

import styles from './styles.module.scss';
import { cn } from 'utils/style';

function Field({ autoComplete, autoCorrect, className, component: Component, label, onBlur, onChange, onFocus, name, type, value: initialValue }) {
  const [value, setValue] = useState(initialValue);
  const [focused, setFocused] = useState(false);

  const handleChange = useCallback((e) => {
    setValue(e.target.value);
    if (onChange) onChange(e);
  }, [onChange]);

  const handleBlur = useCallback((e) => {
    setFocused(false);
    if (onBlur) onBlur(e);
  }, [onBlur]);

  const handleFocus = useCallback((e) => {
    setFocused(true);
    if (onFocus) onFocus(e);
  }, [onFocus]);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);


  return (
    <div className={cn(styles['field-container'], className, focused && styles.focused, !!value && styles.dirty )}>
      <Component
        autoComplete={autoComplete}
        autoCorrect={autoCorrect}
        className={styles.field}
        id={`${name}-field`}
        name={name}
        type={type}
        onBlur={handleBlur}
        onChange={handleChange}
        onFocus={handleFocus}
        value={value}
      />
      <label className={styles.label} htmlFor={`${name}-field`}>{label}</label>
    </div>
  )
}

Field.defaultProps = {
  className: '',
  component: 'input',
  type: 'text',
}

export default Field;
